import _ from 'lodash';

import * as api from '../../api';

import Enum from './Enum';
import { useTranslation } from 'react-i18next';
import { getOptionsFromRecord } from '../utils';

interface Props {
  navigateToNextPage: () => Promise<void>;
  preferredSexOptions: api.Previsit.Sex[];
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  useAlternateEnum: boolean;
  value: string;
}

const DefaultSexOptions = _.pick(
  api.Previsit.sexOptionsMap,
  api.Previsit.DefaultSexes,
);

export function SexInput({
  navigateToNextPage,
  preferredSexOptions,
  saveFieldValue,
  updateFieldValue,
  useAlternateEnum,
  value,
}: Props) {
  const { t } = useTranslation();
  const filteredOptionsMap = preferredSexOptions.length
    ? _.pick(api.Previsit.sexOptionsMap, preferredSexOptions)
    : DefaultSexOptions;
  const displayOptions = getOptionsFromRecord(filteredOptionsMap, t);
  return (
    <Enum
      value={value}
      options={displayOptions}
      onChange={async (option) => {
        updateFieldValue(option);
        await saveFieldValue(option);
        if (useAlternateEnum) navigateToNextPage();
      }}
      useAlternateEnum={useAlternateEnum}
    />
  );
}
